import { FieldError } from "client/lib/apt-merchant";

import { Field } from "../../field";
import { Merchant } from "../../merchant";
import { MerchantField } from "../../types";

import { isNumber } from "./../../validate";

export class BranchNumberField extends Field<string> {
  constructor(model: Merchant, opts: Partial<MerchantField<string>> = {}) {
    super(model, {
      dataType: "string",
      testValue: "1",
      propertyName: "branchNumber",
      uiFieldType: "Input",
      uiInputBaseProps: {
        inputMode: "numeric",
      },
      applicable: true,
      required: true,
      shown: true,
      ...opts,
    });
  }

  _validate() {
    if (typeof this.value !== "undefined") {
      if (!isNumber(this.value)) {
        throw new FieldError(
          this,
          "Value must be a number",
          "InvalidTypeNumber"
        );
      }
    }
  }
}
